const GenericController = class {};

/**
 * Generate a Directive for a given stage
 * @param {string} stage Should be PascalCased
 * @param {string} templateUrl
 * @param {*} controller
 */
const generateDirective = (
  stage,
  templateUrl,
  controller = GenericController
) =>
  angular
    .module('angularAvant')
    .directive(`customerApplications${stage}Stage`, function() {
      return {
        restrict: 'E',
        controller,
        templateUrl
      };
    });

export default generateDirective;
